module.exports = __webpack_public_path__ + "img/appltCourse-img18.c8ca6427.png";